module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contents-box row"
  }, [_c('div', {
    staticClass: "contents-lists"
  }, _vm._l((_vm.txts), function(txt, index) {
    return _c('div', {
      key: index,
      staticClass: "contents-list"
    }, [_c('h3', {
      staticClass: "title-text"
    }, [_vm._v(_vm._s(_vm.$t(("service." + (txt.title)))))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(txt.text))])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ac7cdb8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Service/sservice.vue
// module id = 272
// module chunks = 1